export default __webpack_public_path__ + "static/cupcake-5a1c9620f71cfea68164d2624d3bcf22.svg";